export const TWILIO_ROOM_CREATED = 'TWILIO_ROOM_CREATED'
export const SET_PAYMENT_METHOD = 'SET_PAYMENT_METHOD'
export const VISIT_ENDED = 'VISIT_ENDED'
export const CLEAR_ERROR = 'CLEAR_ERROR'
export const SET_VISIT_STATUS = 'SET_VISIT_STATUS'
export const SET_USER_TRACK_DETAILS = 'SET_USER_TRACK_DETAILS'
export const VISIT_SUSPENDED = 'VISIT_SUSPENDED'
export const VISIT_RESUMED = 'VISIT_RESUMED'
export const SET_WEBSOCKET_CONNECTED = 'SET_WEBSOCKET_CONNECTED'
export const EXTEND_VISIT = 'EXTEND_VISIT'
export const VISIT_UNCONNECTED = 'VISIT_UNCONNECTED'
export const HASH_CHANGED = 'HASH_CHANGED'
export const BREAK_IN_WARNING_RECEIVED = 'BREAK_IN_WARNING_RECEIVED'
export const CLEAR_BREAK_IN_WARNING = 'CLEAR_BREAK_IN_WARNING'
export const VIDEO_SERVICE_INITIALIZED = 'VIDEO_SERVICE_INITIALIZED'

export function roomCreated(roomName, participantIds, serverTimestamp, webrtcToken) {
  return {
    type: TWILIO_ROOM_CREATED,
    roomName,
    participantIds,
    serverTimestamp,
    webrtcToken
  }
}

export function visitEnded(totalMinutes, amountCharged, couponMinutes) {
  return {
    type: VISIT_ENDED,
    totalMinutes,
    amountCharged,
    couponMinutes
  }
}

export function visitSuspended() {
  return {
    type: VISIT_SUSPENDED
  }
}

export function visitResumed() {
  return {
    type: VISIT_RESUMED
  }
}

export function setPaymentMethod(paymentMethod) {
  return {
    type: SET_PAYMENT_METHOD,
    paymentMethod
  }
}

export function visitUnconnected(reason, errorCode) {
  return {
    type: VISIT_UNCONNECTED,
    reason,
    errorCode
  }
}

export function clearError() {
  return {
    type: CLEAR_ERROR
  }
}

export function setVisitStatus(status) {
  return {
    type: SET_VISIT_STATUS,
    status
  }
}

export function setUserTrackDetails(details) {
  return {
    type: SET_USER_TRACK_DETAILS,
    details
  }
}

export function setWebSocketConnected() {
  return {
    type: SET_WEBSOCKET_CONNECTED
  }
}

export function extendVisit(newScheduledEndTime) {
  return {
    type: EXTEND_VISIT,
    newScheduledEndTime
  }
}

export function breakInWarningReceived(message) {
  return {
    type: BREAK_IN_WARNING_RECEIVED,
    message
  }
}

export function clearBreakInWarning() {
  return {
    type: CLEAR_BREAK_IN_WARNING
  }
}

export function videoServiceInitialized(videoService) {
  return {
    type: VIDEO_SERVICE_INITIALIZED,
    videoService
  }
}
